import React from "react";
import { TagInput } from "rsuite";
import { Uploader } from "rsuite";
import { Button, Upload } from "antd";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import { DatePicker } from "rsuite";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const names = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

function getStyles(name, personName, theme) {
  return {
    fontWeight: personName.includes(name)
      ? theme.typography.fontWeightMedium
      : theme.typography.fontWeightRegular,
  };
}

function PatientVisitInfo({ formik }) {
  const multiselectstyles = `
  .css-yi3mkw {
      height: auto;
    min-height: 1.4375em;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    flex-wrap: nowrap;
  }
  `;

  const theme = useTheme();
  const [personName, setPersonName] = React.useState([]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };
  return (
    <>
      <style>{multiselectstyles}</style>
      <div className="row">
        <div className="col-12 d-flex flex-column align-items-start">
          <div className="col-12 d-flex">
            <h5
              className="fw-semibold h5-WOeTzEASAL"
              style={{ color: "rgb(43, 81, 147)", marginTop: "1rem" }}
            >
              Admission/Visit Details
            </h5>
          </div>
        </div>

        <div class="col-md-3 col-12">
          <div class="input-block mb-3">
            <label class="col-form-label lbl-VLJQLgvYMk">
              Date of Admission/Visit<span className="text-danger">*</span>
            </label>
            <DatePicker
              oneTap
              block
              format="dd-MMM-yyyy"
              placeholder="dd-mmm-yyyy"
              name="dateofadmissionvisit"
              value={
                formik.values.dateofadmissionvisit
                  ? new Date(formik.values.dateofadmissionvisit)
                  : null
              }
              onChange={(value) =>
                formik.setFieldValue("dateofadmissionvisit", value ? value.toLocaleDateString('en-CA') : null)
              }
              onBlur={() =>
                formik.setFieldTouched("dateofadmissionvisit", true)
              }
            />
            {formik.touched.dateofadmissionvisit &&
              formik.errors.dateofadmissionvisit && (
                <div style={{ fontSize: "0.8rem", color: "red" }}>
                  {formik.errors.dateofadmissionvisit}
                </div>
              )}
          </div>
        </div>

        <div class="col-md-3 col-12">
          <div class="input-block mb-3">
            <label class="col-form-label lbl-VLJQLgvYMk">
              Expected Discharge Date
            </label>
            <DatePicker
              oneTap
              block
              format="dd-MMM-yyyy"
              placeholder="dd-mmm-yyyy"
              name="expecteddischarge"
              value={
                formik.values.expecteddischarge
                  ? new Date(formik.values.expecteddischarge)
                  : null
              }
              onChange={(value) =>
                formik.setFieldValue("expecteddischarge", value ? value.toLocaleDateString('en-CA') : null)
              }
              onBlur={() => formik.setFieldTouched("expecteddischarge", true)}
            />
            {/* {formik.touched.expecteddischarge &&
              formik.errors.expecteddischarge && (
                <div style={{ fontSize: "0.8rem", color: "red" }}>
                  {formik.errors.expecteddischarge}
                </div>
              )} */}
          </div>
        </div>

        {/* <div class="col-md-3 col-12">
          <div class="input-block mb-3">
            <label class="col-form-label lbl-VLJQLgvYMk">
              Follow-Up Appointment Date<span className="text-danger">*</span>
            </label>
            <DatePicker
      oneTap
      block
      format="dd-MMM-yyyy"
      placeholder="dd-mmm-yyyy"
      name="followupappointmentdate"
      value={
        formik.values.followupappointmentdate
          ? new Date(formik.values.followupappointmentdate)
          : null
      }
      onChange={(value) =>
        formik.setFieldValue("followupappointmentdate", value ? value.toLocaleDateString('en-CA') : null)
      }
      onBlur={() =>
        formik.setFieldTouched("followupappointmentdate", true)
      }
    />
            {formik.touched.followupappointmentdate &&
              formik.errors.followupappointmentdate && (
                <div style={{ fontSize: "0.8rem", color: "red" }}>
                  {formik.errors.followupappointmentdate}
                </div>
              )}
          </div>
        </div> */}     
      </div>
    </>
  );
}

export default PatientVisitInfo;
